import React from 'react';
import { LangContext } from '../../contexts/lang.context';
import { UserInfoContext } from '../../contexts/userInfo.context';
import { ContactCell } from './ContactCell';
import { SectionTitle } from '../ui';
import { Box } from '@material-ui/core';
import { Contact } from '../../models/interfaces';

export const ContactList: React.FC = () => {
  const { CONTACT_SECTION } = React.useContext(LangContext).currentLangData;
  const contacts = React.useContext(UserInfoContext).contacts;

  const now = Date.now();

  const getContactDays = (contacts: { [contactId: string]: Contact }) => {
    const contactArray = Object.values(contacts);
    if (contactArray.length === 0) return [];
    contactArray.sort((a, b) =>
      a.created_at === b.created_at ? 0 : a.created_at > b.created_at ? -1 : 1
    );
    const contactDays: Contact[][] = [];
    contactDays.push([contactArray[0]]);
    for (let i = 1; i < contactArray.length; ++i) {
      const preDiff = getDaysDiff(now, contactArray[i - 1].created_at);
      const curDiff = getDaysDiff(now, contactArray[i].created_at);
      if (preDiff === curDiff) {
        contactDays[contactDays.length - 1].push(contactArray[i]);
      } else {
        contactDays.push([contactArray[i]]);
      }
    }
    return contactDays;
  };

  const getDaysDiff = (now: number, time: number) => {
    const diff = Math.floor((now - time) / 1000 / 3600 / 24);
    return diff >= 0 ? diff : 0;
  };

  const getTitle = (time: number) => {
    const daysDiff = getDaysDiff(now, time);

    return daysDiff === 0 ? CONTACT_SECTION.today : CONTACT_SECTION.contactOfNDaysBefore(daysDiff);
  };

  return (
    <>
      <Box maxWidth={360}>
        {getContactDays(contacts).map((contactsDay, index) => (
          <ContactsPerDay
            key={index}
            title={getTitle(contactsDay[0].created_at)}
            contacts={contactsDay}
          />
        ))}
      </Box>
    </>
  );
};

interface ContactsPerDayProps {
  title: string;
  contacts: Contact[];
}

function ContactsPerDay(props: ContactsPerDayProps) {
  return (
    <>
      <SectionTitle title={props.title} />
      {props.contacts.map((contact) => (
        <ContactCell key={contact.userId} contact={contact} />
      ))}
    </>
  );
}
